import { render, staticRenderFns } from "./AppPopup.vue?vue&type=template&id=95cfa968&scoped=true&"
import script from "./AppPopup.vue?vue&type=script&lang=js&"
export * from "./AppPopup.vue?vue&type=script&lang=js&"
import style0 from "./AppPopup.vue?vue&type=style&index=0&id=95cfa968&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95cfa968",
  null
  
)

export default component.exports